import { fg } from '@atlaskit/platform-feature-flags';

import type { FilterId } from '../../filters';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { SalesforceIcon } from './icon';
import { SalesforceIconBorderless } from './icon-borderless';
import { SalesforceSearchResultIcon } from './search-result-icon';
import { buildSalesforce3PTypeFilterConfig } from './type-filter-config';

export const salesforceConfig: ThirdPartyConfig = {
	displayName: 'Salesforce',
	id: 'salesforce',
	resourceType: 'salesforce-connector',
	icon: get3PLogo(SalesforceIcon, 'Salesforce', 'medium'),
	iconBorderless: get3PLogo(SalesforceIconBorderless, 'Salesforce', 'small'),
	searchResultIcon: get3PLogo(SalesforceSearchResultIcon, 'Salesforce', 'large'),
	integrationAri: 'ari:cloud:platform::integration/salesforce',
	// Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
	// This allows for feature gate mocks in tests to work correctly.
	// NOTE: Must be kept in sync with getSalesforce3PTypeFilterConfig() in
	// type-filter-configs-pure.ts, which drives Type filter pills via getTypeMapping().
	// This getter additionally controls entity ATI request shaping in filters/index.ts
	// when a specific type is selected.
	get typeFilterConfig() {
		return buildSalesforce3PTypeFilterConfig();
	},
	get filters(): FilterId[] {
		const baseFilters: FilterId[] = ['lastUpdated', 'onlyTitleMatch', 'lastUpdatedBy', 'createdBy'];
		if (fg('rovo-fps-3p-ux-salesforce-new-filters-fe-changes')) {
			baseFilters.push('owner');
			baseFilters.push('opportunityStatus');
			baseFilters.push('closeDate');
		}
		if (fg('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) {
			baseFilters.push('salesforceStage');
		}
		if (fg('rovo-fps-3p-ux-sf-campaign-status-filter')) {
			baseFilters.push('campaignStatus');
		}
		if (fg('rovo-fps-3p-ux-sf-case-status-filter')) {
			baseFilters.push('caseStatus');
		}
		return baseFilters;
	},
	requiresOauth: true,
	isEnabled: () => true,
};
